import React from 'react';
import { connect } from 'react-redux';
import Spinner from '../../../components/common/Spinner';
import PageLayout from '../../../components/common/PageLayout';
import UserAdminHeader from '../../../components/common/UserAdminHeader';
import UserEmailNotifications from '../../../components/blocks/UserEmailNotifications';

function UserNotificationsPageContainer(props) {
  if (!props.user) {
    return <Spinner />;
  }

  const pageHero = <UserAdminHeader title="User Email Notifications" />;

  return (
    <PageLayout top={pageHero}>
      <UserEmailNotifications />
    </PageLayout>
  );
}

const mapStateToProps = (state) => {
  const { user } = state.role;

  return {
    user,
  };
};

export default connect(mapStateToProps)(UserNotificationsPageContainer);
